import { Component, EventEmitter, Input,OnInit, Output } from '@angular/core';
import { SharedDataService, SuppliersService, CreditSafeData, Supplier,GetCompanyByVatParameters, SimpleReponseResult, FT_SupplierFinancialStatements_Result} from 'ngx-paf-common';

import { saveAs } from '@progress/kendo-file-saver';
import { PilotageEndelTabComponent } from '../pilotage-endel-tab/pilotage-endel-tab.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'pilotage-analyse-financiere',
  templateUrl: './pilotage-analyse-financiere.component.html',
  styleUrls: ['./pilotage-analyse-financiere.component.scss']
})
export class PilotageAnalyseFinanciereComponent 
    extends PilotageEndelTabComponent 
    implements OnInit{

  reloadTab(): void {
    this.loadLastDatas (true);
  }
  
  supplier?:Supplier=null;
  creditSafeDatas?:CreditSafeData;
  financialStatements: FT_SupplierFinancialStatements_Result[]=[];
  etablissementDatas:CreditSafeData=null;
  constructor(public sharedDataSvc:SharedDataService,
      private suppliersSvc:SuppliersService) {
    super(sharedDataSvc);
  }
  

  ngOnInit(): void {
    this.suppliersSvc.getSupplier(this.supplierId).subscribe((result:Supplier)=>{
      this.supplier = result;
      this.loadLastDatas(true);
    });
  }

  loadLastDatas(retryIfEmpty:boolean = false):void{
    this.creditSafeDatas=undefined;
    if (this.supplier){
      this.loading=true;
      forkJoin({
        creditSafeDatas:this.suppliersSvc.GetCreditSafeDatas(this.supplier.Id),
        financialStatements: this.suppliersSvc.FinancialStatements(this.supplierId)
      }).subscribe((results)=>{
        if ((!results?.creditSafeDatas?.CreditSafeCompanyId) && retryIfEmpty) {
          this.refreshDatas();
          this.loading=false;
          return;
        }
        if (results){
            (<any>results.creditSafeDatas).oCreditSafeCompanyDatas = JSON.parse(results.creditSafeDatas.CreditSafeCompanyDatas);
            (<any>results.creditSafeDatas).oCreditSafeReportDatas = JSON.parse(results.creditSafeDatas.CreditSafeReportDatas);  
        }
        this.creditSafeDatas = results.creditSafeDatas;
        this.financialStatements = results.financialStatements;
        this.loading=false;
      });
    }
  }

  creditSafeErrorMessage:string='';
  refreshDatas():void{
    this.creditSafeErrorMessage='';
    if (!this.supplier) return;
    if (this.supplier?.StatutId != 10) return;

    let params:GetCompanyByVatParameters =  new GetCompanyByVatParameters();
    params.CountryCodes=['EN'];
    if ((this.supplier.Siret||'')!='') {
      params.CountryCodes.push('FR');
      params.Siret=this.supplier?.Siret;
    } else if ((this.supplier.TvaIntra||'')!=''){
      params.VatNumber=this.supplier.TvaIntra;
      if (!params.CountryCodes.some(item=>this.supplier.TvaIntra.toUpperCase().substring(0,2)==item)){
        params.CountryCodes.push(this.supplier.TvaIntra.toUpperCase().substring(0,2));
      }
    } else if ((this.supplier.Duns||'')!='') {
      params.Duns = this.supplier.Duns;
    }
    this.sharedDataSvc.WindowLock();
    this.creditSafeErrorMessage='Recherche en cours...';
    this.suppliersSvc.UpdateCreditSafeDatas(this.supplierId,params)
      .subscribe({
        next:(result:SimpleReponseResult)=>{
          if (result.Ok){
            this.creditSafeErrorMessage = '';
            this.loadLastDatas();
          } else {
            this.creditSafeErrorMessage = 'Rejet CreditSafe : ' + result.Message ;
          }
        }
        ,error:(err:any)=> {this.creditSafeErrorMessage = (err.Message || err)}
        ,complete:()=> this.loading=false
      });
  }

  scoreClass(csd: CreditSafeData):string{
    switch ( csd.ScoreLetter){
      case "A":
      case "B":
        return "badge-success";
      case "C":
        return "badge-warning";
      case "D":
        return "badge-danger";
      default:
        return "badge-secondary";

    }
  }
  getCreditSafePdf(item:CreditSafeData):void{
    this.sharedDataSvc.WindowLock();
    this.suppliersSvc.DownloadCreditSafeReport(item.SupplierId,item.CreditSafeCompanyId)
    .subscribe({
      next: blob => saveAs(blob, item.CreditSafeCompanyId + '.pdf'),
      error:(err:any)=>this.sharedDataSvc.alert('Le rapport complet n\'est pas disponible pour ce fournisseur.',null,'error','Erreur lors du téléchargement du rapport CreditSafe'),
      complete:()=>this.sharedDataSvc.WindowUnlock()
    }
    );
  }

  getScoreLib(csd:CreditSafeData){
    if (isNaN(Number(csd.ScoreValue))){
      return csd.ScoreValue;
    } else {
      return csd.ScoreValue + '/' +csd.ScoreMax;
    }
  }

  ConsolideLib(item:FT_SupplierFinancialStatements_Result):string{
    return item.Consolide ==1 ? 'Oui' : 'Non';
  }

}
